import React,{useState} from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"
import ReactDOM from 'react-dom'
import { Swiper, SwiperSlide } from 'swiper/react';
import { IMAGE_GEEKO_LTD } from "../../../../../constants";
import ProductShopSimlar from "./shop-simlar"
import { useSelector } from "react-redux";

const ImageDisplayer = props =>{
    useStyles(classes);
    const { images, selectedImage,onClose,productId } = props
	const [ initialSlide, setInitialSlide ] = useState((images||[]).indexOf(selectedImage)+1 || 1);
    const ui = useSelector((state) => state.ui)

    const initialOpts = {
		initialSlide:initialSlide-1
	}

	return <div style={{display: !ui.showSearch ? 'block':'none'}} className={classes.AlertImageModal}>
            <div onClick={onClose} className={classes.AlertImage}>
                
                <span className={classes.ImageCount}>
                    <span>{initialSlide}</span>/<span>{images?.length}</span>
                </span>

                <Swiper 
                    slidesPerView='auto'
                    onSlideChange={(swiper) => {
                        setInitialSlide(swiper.realIndex + 1)
                    }}
                    onSwiper={(swiper) => console.log()}
                    {...initialOpts}
                >
                    {
                        images && images.map((image, index) => <SwiperSlide key={index}>
                            <img src={`${IMAGE_GEEKO_LTD}/original/${image}`}/>
                        </SwiperSlide>)
                    }
                </Swiper>

                {/* <ProductShopSimlar 
                    productId={productId} 
                    image={images?.[initialSlide-1]} 
                    onClose={onClose}
                    className={classes.ShopSimlar}
                /> */}
        </div>
    </div>
}

// 
export default props =>{
    if (typeof window === 'undefined')
    return null

    return ReactDOM.createPortal(
        <ImageDisplayer {...props}/>,
        document.getElementById('root')
    )
}